import moment from 'moment'
import ServiceChargeService from '../../services/service-charge.service'
import { ticketSaleSteps } from './../../constants/ticket-sale.constants'
import { createActions, createReducer } from 'reduxsauce'

const initialState = {
	buyerId: '',
	originGoing: null,
	destinationGoing: null,
	originTitle: null,
	originId: null,
	orderValue: 0,
	buyerEmail: '',
	orderNumber: 0,
	passengers: [],
	tripsGoing: [],
	busCompany: '',
	priceGoing: {},
	buyerCity: null,
	serviceGoing: 0,
	tripsReturn: [],
	priceReturn: {},
	muvicardLimit: 0,
	buyerState: null,
	groupGoing: null,
	serviceReturn: 0,
	discountValue: 0,
	buyerStreet: null,
	originReturn: null,
	destinationReturn: null,
	destinationTitle: null,
	destinationId: null,
	groupReturn: null,
	discountLabel: '',
	originState: null,
	discountPercent: 0,
	buyerZipCode: null,
	originIbgeCode: '',
	serviceCharges: [],
	extraDataGoing: {},
	extraDataReturn: {},
	paymentMethod: null,
	destinationState: '',
	selectedTripGoing: 0,
	selectedTripReturn: 0,
	isUpgradeGoing: false,
	isUpgradeReturn: false,
	originLocalityId: null,
	buyerNeighborhood: null,
	destinationIbgeCode: '',
	originPortal: 'Muviflex',
	destinationBusCompany: '',
	confirmedTicketsGoing: [],
	showBpeDownloadLink: false,
	confirmedTicketsReturn: [],
	totalPointsOnTicketSale: 0,
	destinationLocalityId: null,
	selectedServiceCharge: null,
	onlyMoneyOnPriceOption: false,
	raceDateGoing: null,
	raceDateReturn: null,
	stepOrderCurrent: 1,
	saleStep: ticketSaleSteps.busSeatSelectionGoing,
	serviceCharge: {
		value: 0,
		type: 'Valor',
		timestamp: null,
	},
	discountCoupon: {
		code: '',
		isValid: false,
		discountPercentage: 0,
		isPromotion: false,
	},
	selectedPriceGoing: {
		id: 0,
		value: 0,
		points: 0,
		originalValue: 0,
		forSubscribers: false,
	},
	selectedPriceReturn: {
		id: 0,
		value: 0,
		points: 0,
		originalValue: 0,
		forSubscribers: false,
	},
	ordemViagemIda: 0,
	ordemViagemVolta: 0,
	quantidadeViagensda: 0,
	quantidadeViagensVolta: 0,
	etapaPagamento: false,
	requestNumber: '',
	affiliateCode: '',
	origin: null,
	originList: [],
	searchOriginTerm: '',
	destination: null,
	destinationList: [],
	searchDestinationTerm: '',
	tripDateGoingSearch: null,
	tripDateReturnSearch: null,
	tripDateGoing: null,
	tripDateReturn: null,
	boardingTerminalGoing: '',
	disembarkingTerminalGoing: '',
	boardingTerminalReturn: '',
	disembarkingTerminalReturn: '',
	rebookingData: {
		isRebooking: false,
		rebookingOriginId: '',
		rebookingDestinationId: '',
		rebookingValue: 0,
		rebookingTicketId: '',
		purchaseForCustomerId : '',
	},
	isCalculatingValues: false,
	calculatedValues: {
		ticketsGoing: [],
		ticketsReturn: [],
		totalPointsBpe: 0,
		totalConvenienceFee: 0,
		totalOther: 0,
		totalToll: 0,
		totalServiceFee: 0,
		totalFare: 0,
		totalDiscount: 0,
		totalPointsForConvenienceFee: 0,
		totalOrderValue: 0,
		totalBpeValue: 0,
		totalInsuranceValue: 0,
		totalPointsUsed: 0,
		totalInterest: 0,
	},
	familyDiscountParameters: {
		isActive: false,
		percentDiscount: 0,
		busSeatsCondition: 0,
		message: '',
		allowedBusCompanys: '',
	},
	familyDiscountAllowed: false,
	familyDiscountApplied: false,
}

const getServiceCharge = (timestamp) => (dispatch) => {
	const halfHour = 30 * 60 * 1000
	const cantGetServiceCharge = timestamp && new Date() - timestamp < halfHour
	if (cantGetServiceCharge) return
	return ServiceChargeService.getServiceCharge().then((data) =>
		dispatch(Creators.setServiceCharges(data))
	)
}

export const { Types, Creators } = createActions(
	{
		reset: null,
		getServiceCharge,
		goToNextStep: null,
		resetBuyerAddress: null,
		setPriceGoing: ['data'],
		setPriceReturn: ['data'],
		updateOriginGoing: ['originGoing'],
		updateOriginReturn: ['originReturn'],
		backToPreviousStep: null,
		resetDiscountCoupon: null,
		busCompany: ['busCompany'],
		setExtraDataGoing: ['data'],
		setExtraDataReturn: ['data'],
		setOriginPortal: ['originPortal'],
		paymentMethod: ['paymentMethod'],
		setSelectedPriceGoing: ['price'],
		updateTripsGoing: ['tripsGoing'],
		discountLabel: ['discountLabel'],
		discountValue: ['discountValue'],
		setBuyerAddress: ['buyerAddress'],
		setSelectedPriceReturn: ['price'],
		updateDestinationGoing: ['destinationGoing'],
		updateDestinationReturn: ['destinationReturn'],
		updateTripsReturn: ['tripsReturn'],
		setSelectedTripGoing: ['tripIndex'],
		setSelectedTripReturn: ['tripIndex'],
		discountPercent: ['discountPercent'],
		setDiscountCoupon: ['discountCoupon'],
		setIsUpgradeGoing: ['isUpgradeGoing'],
		setServiceCharges: ['serviceCharges'],
		setIsUpgradeReturn: ['isUpgradeReturn'],
		setServiceCharge: ['chargeType', 'value'],
		setGroupAndServiceGoing: ['group', 'service'],
		setGroupAndServiceReturn: ['group', 'service'],
		onlyMoneyOnPriceOption: ['onlyMoneyOnPriceOption'],
		setSelectedServiceCharge: ['selectedServiceCharge'],
		updateTripDates: ['tripDateGoing', 'tripDateReturn'],
		totalPointsOnTicketSale: ['totalPointsOnTicketSale'],
		setConfirmedPurchaseData: [
			'confirmedPurchaseData',
			'purchaseRequestData',
		],
		resetOrdemViagemIda: null,
		ordemViagemIda: null,
		setEtapaPagamento: ['etapaPagamento'],
		setStepOrderCurrent: ['stepOrderCurrent'],
		setTripData: ['tripData'],
		setRequestNumber: ['requestNumber'],
		resetRequestNumber: null,
		setAffiliateCode: ['affiliateCode'],
		resetAffiliateCode: null,
		setOrigin: ['origin'],
		setOriginList: ['originList'],
		setSearchOriginTerm: ['searchOriginTerm'],
		setDestination: ['destination'],
		setDestinationList: ['destinationList'],
		setSearchDestinationTerm: ['searchDestinationTerm'],
		setTripDateGoingSearch: ['tripDateGoingSearch'],
		setTripDateReturnSearch: ['tripDateReturnSearch'],
		setTripEmbarcationGoing: ['boardingTerminal', 'disembarkingTerminal'],
		setTripEmbarcationReturn: ['boardingTerminal', 'disembarkingTerminal'],
		resetTripEmbarcationGoing: null,
		resetTripEmbarcationReturn: null,
		setRebookingData: ['rebookingData'],
		resetRebookingData: null,
		setCalculatedValues: ['calculatedValues'],
		resetCalculatedValues: ['resetCalculatedValues'],
		setIsCalculatingValues: ['isCalculatingValues'],
		setFamilyDiscountParameters: ['familyDiscountParameters'],
		setFamilyDiscountAllowed: ['familyDiscountAllowed'],
		setFamilyDiscountApplied: ['familyDiscountApplied'],
	},
	{
		prefix: 'ticket-sale/',
	}
)

const totalPointsOnTicketSale = (
	state = intialState,
	{ totalPointsOnTicketSale }
) => ({
	...state,
	totalPointsOnTicketSale,
})

const paymentMethod = (state = intialState, { paymentMethod }) => ({
	...state,
	paymentMethod,
})

const setOriginPortal = (state = initialState, { originPortal }) => ({
	...state,
	originPortal,
})

const discountLabel = (state = intialState, { discountLabel }) => ({
	...state,
	discountLabel,
})
const discountPercent = (state = intialState, { discountPercent }) => ({
	...state,
	discountPercent,
})
const discountValue = (state = intialState, { discountValue }) => ({
	...state,
	discountValue,
})

const setEtapaPagamento = (state = intialState, { etapaPagamento }) => ({
	...state,
	etapaPagamento,
})

const busCompany = (state = intialState, { busCompany }) => ({
	...state,
	busCompany,
})

const onlyMoneyOnPriceOption = (
	state = intialState,
	{ onlyMoneyOnPriceOption }
) => ({
	...state,
	onlyMoneyOnPriceOption,
})

const setServiceCharge = (state = intialState, { chargeType, value }) => ({
	...state,
	serviceCharge: {
		value,
		type: chargeType,
		timestamp: new Date(),
	},
})

const setBuyerAddress = (state = initialState, { buyerAddress }) => ({
	...state,
	buyerCity: buyerAddress.city,
	buyerState: buyerAddress.state,
	buyerStreet: buyerAddress.street,
	buyerZipCode: buyerAddress.zipCode,
	buyerNeighborhood: buyerAddress.neighborhood,
})

const resetBuyerAddress = (state = initialState) => ({
	...state,
	buyerCity: null,
	buyerState: null,
	buyerStreet: null,
	buyerZipCode: null,
	buyerNeighborhood: null,
})

const goToNextStep = (state = initialState) => ({
	...state,
	saleStep: getNextStep(state),
})

const setConfirmedPurchaseData = (
	state = initialState,
	{ confirmedPurchaseData, purchaseRequestData }
) => {
	const { passengersValues, buyerValues } = purchaseRequestData

	const {
		pixData,
		buyerId,
		orderValue,
		orderNumber,
		bankSlipLink,
		muvicardLimit,
		showBpeDownloadLink,
		confirmedTicketsGoing,
		confirmedTicketsReturn,
		anticipatedPix,
	} = confirmedPurchaseData

	return {
		...state,
		pixData,
		buyerId,
		orderValue,
		orderNumber,
		bankSlipLink,
		muvicardLimit,
		showBpeDownloadLink,
		confirmedTicketsGoing,
		confirmedTicketsReturn,
		passengers: passengersValues,
		buyerEmail: buyerValues.email,
		anticipatedPix,
	}
}

const setTripEmbarcationGoing = (state = initialState, action) => {
	const { boardingTerminal, disembarkingTerminal } = action.boardingTerminal

	return {
		...state,
		boardingTerminalGoing: boardingTerminal,
		disembarkingTerminalGoing: disembarkingTerminal,
	}
}

const resetTripEmbarcationGoing = (state = initialState) => ({
	...state,
	boardingTerminalGoing: '',
	disembarkingTerminalGoing: '',
})

const setTripEmbarcationReturn = (state = initialState, action) => {
	const { boardingTerminal, disembarkingTerminal } = action.boardingTerminal
	return {
		...state,
		boardingTerminalReturn: boardingTerminal,
		disembarkingTerminalReturn: disembarkingTerminal,
	}
}

const resetTripEmbarcationReturn = (state = initialState) => ({
	...state,
	boardingTerminalReturn: '',
	disembarkingTerminaLReturn: '',
})

const backToPreviousStep = (state = initialState) => ({
	...state,
	saleStep: getPreviousStep(state),
})

const setSelectedTripGoing = (state = initialState, { tripIndex }) => ({
	...state,
	selectedTripGoing: tripIndex,
})

const setSelectedTripReturn = (state = initialState, { tripIndex }) => ({
	...state,
	selectedTripReturn: tripIndex,
})

const setSelectedPriceGoing = (state = initialState, { price }) => ({
	...state,
	selectedPriceGoing: price,
})

const setSelectedPriceReturn = (state = initialState, { price }) => ({
	...state,
	selectedPriceReturn: price,
})

const setDiscountCoupon = (state = initialState, { discountCoupon }) => {
	return {
		...state,
		discountCoupon,
	}
}

const setStepOrderCurrent = (state = initialState, { stepOrderCurrent }) => ({
	...state,
	stepOrderCurrent: stepOrderCurrent,
})

const resetDiscountCoupon = (state = initialState) => ({
	...state,
	discountCoupon: {
		code: '',
		isValid: false,
		discountPercentage: 0,
		isPromotion: false,
	},
})

const updateOriginGoing = (state = initialState, { originGoing }) => ({
	...state,
	originGoing: originGoing.origem || '',
	originGoingId: originGoing.origemId,
})

const updateDestinationGoing = (
	state = initialState,
	{ destinationGoing }
) => ({
	...state,
	destinationGoing: destinationGoing.destino || '',
	destinationGoingId: destinationGoing.destinoId,
})

const updateOriginReturn = (state = initialState, { originReturn }) => ({
	...state,
	originReturn: originReturn.origem || '',
	originReturnId: originReturn.origemId,
})

const updateDestinationReturn = (
	state = initialState,
	{ destinationReturn }
) => ({
	...state,
	destinationReturn: destinationReturn.destino || '',
	destinationReturnId: destinationReturn.destinoId,
})

const updateTripDates = (state = intialState, { tripDateGoing }) => {
	const { tripDateGoingSearch, tripDateReturnSearch } = tripDateGoing
	return {
		...state,
		tripDateGoing: moment(tripDateGoingSearch, 'YYYY-MM-DD').toDate(),
		tripDateReturn: tripDateReturnSearch
			? moment(tripDateReturnSearch, 'YYYY-MM-DD').toDate()
			: null,
	}
}

const updateTripsGoing = (state = initialState, { tripsGoing }) => ({
	...state,
	tripsGoing,
})

const updateTripsReturn = (state = initialState, { tripsReturn }) => ({
	...state,
	tripsReturn,
})

const setGroupAndServiceGoing = (state = initialState, { group, service }) => ({
	...state,
	groupGoing: group,
	serviceGoing: service,
})

const setGroupAndServiceReturn = (
	state = initialState,
	{ group, service }
) => ({
	...state,
	groupReturn: group,
	serviceReturn: service,
})

const setRequestNumber = (state = initialState, { requestNumber }) => ({
	...state,
	requestNumber,
})

const resetRequestNumber = (state = initialState) => ({
	...state,
	requestNumber: '',
})

const setAffiliateCode = (state = initialState, { affiliateCode }) => ({
	...state,
	affiliateCode,
})

const resetAffiliateCode = (state = initialState) => ({
	...state,
	affiliateCode: '',
})

const setOrigin = (state = initialState, { origin }) => ({
	...state,
	origin,
})

const setOriginList = (state = initialState, { originList }) => ({
	...state,
	originList,
})

const setSearchOriginTerm = (state = initialState, { searchOriginTerm }) => ({
	...state,
	searchOriginTerm,
})

const setDestination = (state = initialState, { destination }) => ({
	...state,
	destination,
})

const setDestinationList = (state = initialState, { destinationList }) => ({
	...state,
	destinationList,
})

const setSearchDestinationTerm = (
	state = initialState,
	{ searchDestinationTerm }
) => ({
	...state,
	searchDestinationTerm,
})

const setTripDateGoingSearch = (
	state = initialState,
	{ tripDateGoingSearch }
) => ({
	...state,
	tripDateGoingSearch: moment(tripDateGoingSearch, 'YYYY-MM-DD').toDate(),
})

const setTripDateReturnSearch = (
	state = initialState,
	{ tripDateReturnSearch }
) => ({
	...state,
	tripDateReturnSearch: moment(tripDateReturnSearch, 'YYYY-MM-DD').toDate(),
})

const setRebookingData = (state = initialState, { rebookingData }) => ({
	...state,
	rebookingData,
})

const resetRebookingData = (state = initialState) => ({
	...state,
	rebookingData: initialState.rebookingData,
})

const setFamilyDiscountParameters = (
	state = initialState,
	{ familyDiscountParameters }
) => ({
	...state,
	familyDiscountParameters: familyDiscountParameters.discountFamily,
})

const reset = (state = intialState) => ({
	...state,
	orderValue: 0,
	passengers: [],
	tripsGoing: [],
	orderNumber: 0,
	tripsReturn: [],
	serviceGoing: 0,
	muvicardLimit: 0,
	groupGoing: null,
	serviceReturn: 0,
	groupReturn: null,
	raceDateGoing: null,
	raceDateReturn: null,
	extraDataGoing: {},
	extraDataReturn: {},
	isUpgradeGoing: false,
	isUpgradeReturn: false,
	originPortal: 'Muviflex',
	confirmedTicketsGoing: [],
	confirmedTicketsReturn: [],
	selectedServiceCharge: null,
	saleStep: ticketSaleSteps.busSeatSelectionGoing,
	selectedPriceGoing: {
		id: 0,
		value: 0,
		points: 0,
		originalValue: 0,
		forSubscribers: false,
	},
	selectedPriceReturn: {
		id: 0,
		value: 0,
		points: 0,
		originalValue: 0,
		forSubscribers: false,
	},
	ordemViagemIda: 0,
	ordemViagemVolta: 0,
	quantidadeViagensda: 0,
	quantidadeViagensVolta: 0,
	etapaPagamento: false,
	requestNumber: '',
	affiliateCode: '',
	boardingTerminalGoing: '',
	disembarkingTerminalGoing: '',
	boardingTerminalReturn: '',
	disembarkingTerminalReturn: '',
	isCalculatingValues: false,
	calculatedValues: {
		ticketsGoing: [],
		ticketsReturn: [],
		totalPointsBpe: 0,
		totalConvenienceFee: 0,
		totalOther: 0,
		totalToll: 0,
		totalServiceFee: 0,
		totalFare: 0,
		totalDiscount: 0,
		totalPointsForConvenienceFee: 0,
		totalOrderValue: 0,
		totalBpeValue: 0,
		totalInsuranceValue: 0,
		totalPointsUsed: 0,
		totalInterest: 0,
	},
	familyDiscountParameters: {
		isActive: false,
		percentDiscount: 0,
		busSeatsCondition: 0,
		message: '',
		allowedBusCompanys: '',
	},
	familyDiscountAllowed: false,
	familyDiscountApplied: false,
})

const setExtraDataGoing = (
	state = initialState,
	{ data: { tax, fee, toll, insurance, lineCode, destinationCode } }
) => ({
	...state,
	extraDataGoing: { fee, tax, toll, insurance, lineCode, destinationCode },
})

const setPriceGoing = (
	state = initialState,
	{ data: { fee, insurance, other, price, tax, toll } }
) => ({
	...state,
	priceGoing: { fee, insurance, other, price, tax, toll },
})

const setPriceReturn = (
	state = initialState,
	{ data: { fee, insurance, other, price, tax, toll } }
) => ({
	...state,
	priceReturn: { fee, insurance, other, price, tax, toll },
})

const setExtraDataReturn = (
	state = initialState,
	{ data: { tax, fee, toll, insurance, lineCode, destinationCode } }
) => ({
	...state,
	extraDataReturn: { fee, tax, toll, insurance, lineCode, destinationCode },
})

const setServiceCharges = (state = initialState, { serviceCharges }) => ({
	...state,
	serviceCharges,
})

const setIsUpgradeGoing = (state = initialState, { isUpgradeGoing }) => ({
	...state,
	isUpgradeGoing,
})

const setIsUpgradeReturn = (state = initialState, { isUpgradeReturn }) => ({
	...state,
	isUpgradeReturn,
})

const setSelectedServiceCharge = (
	state = intialState,
	{ selectedServiceCharge }
) => {
	const isBusSeatSelectionReturn =
		state.saleStep == ticketSaleSteps.busSeatSelectionReturn

	if (state.selectedServiceCharge !== null && isBusSeatSelectionReturn) {
		const currentServiceCharge = state.serviceCharges.find(
			({ purchaseOption }) => purchaseOption == state.selectedServiceCharge
		)
		const nextServiceCharge = state.serviceCharges.find(
			({ purchaseOption }) => purchaseOption == selectedServiceCharge
		)

		if (currentServiceCharge.value > nextServiceCharge.value) {
			return state
		}
	}

	return {
		...state,
		selectedServiceCharge,
	}
}

const setTripData = (state = initialState, { tripData }) => ({
	...state,
	...tripData,
})

const setCalculatedValues = (state = initialState, { calculatedValues }) => ({
	...state,
	calculatedValues,
})

const resetCalculatedValues = (state = initialState) => ({
	...state,
	calculatedValues: initialState.calculatedValues,
})

const setIsCalculatingValues = (
	state = initialState,
	{ isCalculatingValues }
) => ({
	...state,
	isCalculatingValues,
})

const setFamilyDiscountAllowed = (
	state = initialState,
	{ familyDiscountAllowed }
) => ({
	...state,
	familyDiscountAllowed,
})

const setFamilyDiscountApplied = (
	state = initialState,
	{ familyDiscountApplied }
) => ({
	...state,
	familyDiscountApplied,
})

export default createReducer(initialState, {
	[Types.RESET]: reset,
	[Types.BUS_COMPANY]: busCompany,
	[Types.UPDATE_ORIGIN_GOING]: updateOriginGoing,
	[Types.UPDATE_ORIGIN_RETURN]: updateOriginReturn,
	[Types.GO_TO_NEXT_STEP]: goToNextStep,
	[Types.PAYMENT_METHOD]: paymentMethod,
	[Types.DISCOUNT_LABEL]: discountLabel,
	[Types.DISCOUNT_VALUE]: discountValue,
	[Types.SET_ETAPA_PAGAMENTO]: setEtapaPagamento,
	[Types.SET_PRICE_GOING]: setPriceGoing,
	[Types.SET_PRICE_RETURN]: setPriceReturn,
	[Types.DISCOUNT_PERCENT]: discountPercent,
	[Types.SET_ORIGIN_PORTAL]: setOriginPortal,
	[Types.SET_BUYER_ADDRESS]: setBuyerAddress,
	[Types.UPDATE_TRIP_DATES]: updateTripDates,
	[Types.SET_SERVICE_CHARGE]: setServiceCharge,
	[Types.UPDATE_TRIPS_GOING]: updateTripsGoing,
	[Types.UPDATE_DESTINATION_GOING]: updateDestinationGoing,
	[Types.UPDATE_DESTINATION_RETURN]: updateDestinationReturn,
	[Types.RESET_BUYER_ADDRESS]: resetBuyerAddress,
	[Types.SET_DISCOUNT_COUPON]: setDiscountCoupon,
	[Types.SET_SERVICE_CHARGES]: setServiceCharges,
	[Types.UPDATE_TRIPS_RETURN]: updateTripsReturn,
	[Types.SET_EXTRA_DATA_GOING]: setExtraDataGoing,
	[Types.SET_IS_UPGRADE_GOING]: setIsUpgradeGoing,
	[Types.BACK_TO_PREVIOUS_STEP]: backToPreviousStep,
	[Types.SET_EXTRA_DATA_RETURN]: setExtraDataReturn,
	[Types.SET_IS_UPGRADE_RETURN]: setIsUpgradeReturn,
	[Types.RESET_DISCOUNT_COUPON]: resetDiscountCoupon,
	[Types.SET_SELECTED_TRIP_GOING]: setSelectedTripGoing,
	[Types.SET_SELECTED_PRICE_GOING]: setSelectedPriceGoing,
	[Types.SET_SELECTED_TRIP_RETURN]: setSelectedTripReturn,
	[Types.SET_SELECTED_PRICE_RETURN]: setSelectedPriceReturn,
	[Types.ONLY_MONEY_ON_PRICE_OPTION]: onlyMoneyOnPriceOption,
	[Types.TOTAL_POINTS_ON_TICKET_SALE]: totalPointsOnTicketSale,
	[Types.SET_GROUP_AND_SERVICE_GOING]: setGroupAndServiceGoing,
	[Types.SET_CONFIRMED_PURCHASE_DATA]: setConfirmedPurchaseData,
	[Types.SET_SELECTED_SERVICE_CHARGE]: setSelectedServiceCharge,
	[Types.SET_GROUP_AND_SERVICE_RETURN]: setGroupAndServiceReturn,
	[Types.SET_STEP_ORDER_CURRENT]: setStepOrderCurrent,
	[Types.SET_TRIP_DATA]: setTripData,
	[Types.SET_REQUEST_NUMBER]: setRequestNumber,
	[Types.RESET_REQUEST_NUMBER]: resetRequestNumber,
	[Types.SET_AFFILIATE_CODE]: setAffiliateCode,
	[Types.RESET_AFFILIATE_CODE]: resetAffiliateCode,
	[Types.SET_ORIGIN]: setOrigin,
	[Types.SET_ORIGIN_LIST]: setOriginList,
	[Types.SET_SEARCH_ORIGIN_TERM]: setSearchOriginTerm,
	[Types.SET_DESTINATION]: setDestination,
	[Types.SET_DESTINATION_LIST]: setDestinationList,
	[Types.SET_SEARCH_DESTINATION_TERM]: setSearchDestinationTerm,
	[Types.SET_TRIP_DATE_GOING_SEARCH]: setTripDateGoingSearch,
	[Types.SET_TRIP_DATE_RETURN_SEARCH]: setTripDateReturnSearch,
	[Types.SET_TRIP_EMBARCATION_GOING]: setTripEmbarcationGoing,
	[Types.SET_TRIP_EMBARCATION_RETURN]: setTripEmbarcationReturn,
	[Types.RESET_TRIP_EMBARCATION_GOING]: resetTripEmbarcationGoing,
	[Types.RESET_TRIP_EMBARCATION_RETURN]: resetTripEmbarcationReturn,
	[Types.SET_REBOOKING_DATA]: setRebookingData,
	[Types.RESET_REBOOKING_DATA]: resetRebookingData,
	[Types.SET_CALCULATED_VALUES]: setCalculatedValues,
	[Types.RESET_CALCULATED_VALUES]: resetCalculatedValues,
	[Types.SET_IS_CALCULATING_VALUES]: setIsCalculatingValues,
	[Types.SET_FAMILY_DISCOUNT_PARAMETERS]: setFamilyDiscountParameters,
	[Types.SET_FAMILY_DISCOUNT_ALLOWED]: setFamilyDiscountAllowed,
	[Types.SET_FAMILY_DISCOUNT_APPLIED]: setFamilyDiscountApplied,
})

const getNextStep = (state) => {
	switch (state.saleStep) {
		case ticketSaleSteps.busSeatSelectionGoing:
			return !!state.tripsReturn.length
				? ticketSaleSteps.busSeatSelectionReturn
				: ticketSaleSteps.payment
		case ticketSaleSteps.busSeatSelectionReturn:
			return ticketSaleSteps.payment
		case ticketSaleSteps.payment:
			return ticketSaleSteps.confirmation
		default:
			return ticketSaleSteps.busSeatSelectionGoing
	}
}

const getPreviousStep = (state) => {
	switch (state.saleStep) {
		case ticketSaleSteps.payment:
			return state.tripsReturn.length == 0
				? ticketSaleSteps.busSeatSelectionGoing
				: ticketSaleSteps.busSeatSelectionReturn
		case ticketSaleSteps.busSeatSelectionReturn:
			return ticketSaleSteps.busSeatSelectionGoing
		default:
			return ticketSaleSteps.busSeatSelectionGoing
	}
}

function getEtapaPagamento() {
	return dispatch({
		payload: null,
		type: GET_ETAPA_PAGAMENTO,
	})
}

export function ticketSaleReducer(state = initialState, action) {
	switch (action.type) {
		default:
			return state
	}
}

export const ticketSaleActions = {
	getEtapaPagamento,
	setRequestNumber,
	setAffiliateCode,
	setTripEmbarcationGoing,
	setTripEmbarcationReturn,
	setCalculatedValues,
	resetCalculatedValues,
	setFamilyDiscountParameters,
	setFamilyDiscountApplied,
}
